<template>
  <div>
    <v-data-table
      id="personsTable"
      fixed-header
      :loading="loading"
      :no-data-text="responseMessage"
      :loading-text="
        $t('fleet_management.persons.persons_table.labels.label_loading_text')
      "
      :height="dataTableHeight"
      :headers="headers"
      :header-props="headerProps"
      :items="persons"
      item-key="id"
      :custom-sort="customSort"
      sort-by="fullName"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <div class="card--title">
          <v-toolbar height="57" rounded="lg" flat>
            <v-toolbar-title
              >{{
                $t('fleet_management.persons.persons_tab_all.labels.card_title')
              }}
              ({{ totalPersons }})</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <router-link :to="{ name: 'NewPerson' }">
              <v-btn
              v-if="isAdmin || isAdminSubFleet"
              text
              @click="newPerson"
              id="idPersonasAgregarPersonas"
              >
              <SvgIcon class="tertiary--text" iconType="icon_new_user" />
              <span class="text-capitalize text-body-2">{{
                $t(
                  'fleet_management.persons.persons_tab_all.labels.card_add_user_button'
                )
              }}</span>
            </v-btn>
          </router-link>
          </v-toolbar>
        </div>
      </template>
      <!-- STARTS OF ITEMS SLOTS -->

      <template v-slot:item.fullName="{ item }">
        <v-tooltip top content-class="secondary white--text text-subtitle-2">
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              class="secondary--text searchable label-links"
              @click="viewPersonDetail(item)"
              >{{ item.fullName }}</span
            >
          </template>
          <span>{{ item.fullName }}</span>
          <div class="tooltip-arrow"></div>
        </v-tooltip>
      </template>
      <template v-slot:item.email="{ item }">
        <div
          dense
          flat
          class="secondary--text searchable"
          :key="index"
          v-for="(email, index) in item.emails"
        >
          {{ email.email }}
        </div>
      </template>
      <template v-slot:item.roles="{ item }">
        <div v-if="item.roles.length > 0">
          <v-chip :key="index" class="ma-2" v-for="(role, index) in item.roles">
            {{
              $t(
                `fleet_management.persons.persons_table.labels.data_table_field_rol_${role}`
              )
            }}
            <span class="pl-1" v-if="showUserProfile(item, index)">{{
              getUserProfile(item)
            }}</span>
          </v-chip>
        </div>
        <div v-else>
          <v-chip>
            {{
              $t(
                `fleet_management.persons.persons_table.labels.data_table_field_rol_`
              )
            }}
          </v-chip>
        </div>
      </template>

      <template v-slot:item.thingsAssignments="{ item }">
        <v-menu
          top
          rounded-xl
          :open-on-hover="contentBadge(item.uriId)"
          :open-on-click="false"
          transition="scale-transition"
          min-width="30px"
          allow-overflow
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-badge
                :content="contentBadge(item.uriId)"
                :value="contentBadge(item.uriId)"
                color="tertiary"
                overlap
              >
                <SvgIcon
                  iconType="icon_truck"
                  :class="[contentBadge(item.uriId) == 0 ? 'grey--text' : '']"
                />
              </v-badge>
            </div>
          </template>
          <v-card max-width="300" class="pl-2 scrollable-card">
            <v-chip-group v-if="getThingsAssignments[item.uriId]" column>
              <v-chip
                v-for="{ id, info } in $store.state.persons.thingsAssignments[
                  item.uriId
                ]"
                :key="id"
                small
              >
                {{ info.label }}
              </v-chip>
            </v-chip-group>
          </v-card>
        </v-menu>
      </template>

      <template v-slot:item.info="{ item, index }">
        <v-menu
          offset-x
          nudge-left="12"
          nudge-top="4"
          left
          rounded-xl
          content-class="white pa-1"
        >
          <template v-slot:activator="{ on, attrs, value }">
            <v-btn
              :id="`idPersonasKebabMenuPersonas${index}`"
              :class="[value ? '' : 'btn__activator-not-focus']"
              icon
              v-bind="attrs"
              v-on="on"
            >
              <SvgIcon class="secondary--text" iconType="icon_ellipses" />
            </v-btn>
          </template>
          <div>
            <v-btn text @click="viewPersonDetail(item)">
              <v-icon small color="secondary" class="mr-1">
                mdi-information-outline
              </v-icon>
              <span class="text-body-2 text-capitalize">{{
                $t(
                  'fleet_management.persons.persons_table.labels.button_detail'
                )
              }}</span>
            </v-btn>
            <v-btn
              v-if="!isLoggedUser(item) && isAdmin || item.created_by === loggedUser"
              @click="deletePerson(item)"
              text
              id="idBtnPersonasEliminar"
            >
              <v-icon small color="primary" class="mr-1">
                mdi-trash-can-outline
              </v-icon>
              <span class="text-body-2 text-capitalize">{{
                $t(
                  'fleet_management.persons.persons_table.labels.button_delete'
                )
              }}</span>
            </v-btn>
          </div>
        </v-menu>
      </template>
    </v-data-table>
    <Dialog
      idCancelButton="idBtnPersonasNo"
      idSubmitButton="idBtnPersonasSi"
      :showDialog="showDialog"
      :text="dialog.text"
      :closeButtonText="dialog.closeButtonText"
      :submitButtonText="dialog.acceptButtonText"
      :oneButton="dialog.oneButtonDialog"
      :oneButtonText="dialog.oneButtonText"
      :type="dialog.type"
      :loading="dialog.loading"
      @cancelButtonPressed="cancelDialog"
      @submitButtonPressed="submitPersonDelete"
      @oneButtonAction="cancelDialog"
      class="ma-0"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { i18n, FirebaseTagNames } from '@leapsight/portal'
import { SvgIcon, firebaseServices } from '@leapsight/styleguide'
import Dialog from '@/components/dialog/Dialog'
import store from '@/store'
import Mark from 'mark.js'
import personsHelpers from '@/helpers/persons/personsHelpers'

export default {
  components: {
    SvgIcon,
    Dialog
  },
  data() {
    return {
      context: '',
      dataTableHeight: 0,
      dialog: {
        text: '',
        closeButtonText: i18n.t('general.dialogComponent.closeButtonText'),
        acceptButtonText: i18n.t('general.dialogComponent.acceptButtonText'),
        type: '',
        loading: false,
        oneButtonText: '',
        oneButtonDialog: false
      },
      headers: [
        {
          text: i18n.t(
            'fleet_management.persons.persons_table.labels.data_table_header_name'
          ),
          align: 'center',
          value: 'fullName',
          class: 'secondary--text ml-4'
        },
        {
          text: i18n.t(
            'fleet_management.persons.persons_table.labels.data_table_header_mail'
          ),
          align: 'center',
          value: 'email',
          class: 'secondary--text ml-4'
        },
        {
          text: i18n.t(
            'fleet_management.persons.persons_table.labels.data_table_header_roles'
          ),
          align: 'center',
          value: 'roles',
          class: 'secondary--text ml-4'
        },
        {
          text: 'Entidades asignadas',
          width: 150,
          align: 'center',
          value: 'thingsAssignments',
          class: 'secondary--text',
          sortable: false
        },
        {
          text: '',
          align: 'center',
          sortable: false,
          value: 'info'
        }
      ],
      headerProps: {
        sortByText: i18n.t(
          'fleet_management.persons.persons_table.labels.data_table_header_mobile_sort_by'
        )
      },
      loading: false,
      loggedUser: localStorage.getItem('user_id'),
      markInstance: {},
      matchPosition: 1,
      personToDelete: {},
      searchMatch: [],
      showDialog: false
    }
  },
  methods: {
    ...mapActions(['setSearchMatch']),
    newPerson() {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        FirebaseTagNames.BTN_FLEET_MANAGEMENT_ADD_PERSON
      )
    },
    cancelDialog() {
      this.showDialog = false
    },
    deletePerson(item) {
      const { first_name: firstName, last_name: lastName } = item
      this.dialog.oneButtonDialog = false
      this.showDialog = true
      this.dialog.text = i18n.t(
        'fleet_management.persons.persons_table.labels.delete_person.dialog_text',
        { firstName, lastName }
      )
      this.dialog.type = 'warning'
      this.dialog.closeButtonText = i18n.t(
        'fleet_management.agents.delete_agent.labels.dialog_closeButton'
      )
      this.dialog.acceptButtonText = i18n.t(
        'fleet_management.agents.delete_agent.labels.dialog_acceptButton'
      )

      this.personToDelete = item
    },
    isLoggedUser(item) {
      return this.loggedUser === item.uriId ? true : false
    },
    getPersonsList() {
      this.loading = true
      store.dispatch('persons/resetPersonsState')

      personsHelpers
        .getPersonsList()
        .then(response => {
          store.dispatch('persons/setResponseError', false)
          if (response.args.length > 0) {
            const persons = response.args[0]
            store.dispatch('persons/setPersons', persons)
          }
        })
        .catch(error => {
          store.dispatch('persons/setResponseError', true)
          console.log(error)
        })
    },
    searchAndHighlight(inputTerm) {
      const keyword = inputTerm
      const marked = this.markInstance?.unmark ? this.markInstance : new Mark()
      const actualThis = this
      this.searchMatch = []

      marked.unmark({
        done: function() {
          marked.mark(keyword, {
            separateWordSearch: false,
            noMatch: function(term) {
              // Esta funcion se ejecuta cuando no hay match
            },
            each: function(node) {
              // Array con los row que machean a la busqueda
              actualThis.searchMatch.push(node.closest('tr'))
            }
          })
        }
      })

      this.setSearchMatch(this.searchMatch)
      // //Damos estilo al match activo si el listado de nodos encontrados es mayor a 0
      const activePosition = document.querySelectorAll('mark')

      if (activePosition.length > 0)
        //activePosition[this.matchPosition - 1].style.backgroundColor = '#FFA726'
        activePosition[this.matchPosition - 1].classList.add('activeMatch')

      // // Scrollintoview para el match activo
      if (this.searchMatch.length > 0) {
        const selectedRow = this.searchMatch[this.matchPosition - 1]
        const dataTablelastRow = document.querySelector(
          '#personsTable .v-data-table__wrapper table tbody tr:last-child'
        )
        const tableHeader = document.querySelector('.v-data-table-header')
          .clientHeight
        const barToScroll = document.querySelector(
          '#personsTable .v-data-table__wrapper'
        )
        selectedRow.scrollIntoView()

        if (selectedRow === dataTablelastRow) {
          barToScroll.scrollBy({
            top: 0,
            behaviour: 'smooth'
          })
        } else {
          barToScroll.scrollBy({
            top: -tableHeader,
            behaviour: 'smooth'
          })
        }
      }
    },
    async submitPersonDelete() {
      const id = this.personToDelete.uriId
      try {
        this.dialog.loading = true
        await personsHelpers.deletePerson(id)
        this.dialog.loading = false
        this.dialog.type = 'success'
        this.dialog.text = i18n.t('general.dialogComponent.title_success')
        this.dialog.oneButtonDialog = true
        this.dialog.oneButtonText = i18n.t(
          'general.dialogComponent.acceptButtonText'
        )
        this.getPersonsList()
      } catch (error) {
        const errorText = personsHelpers.getErrorMessageByCode(error.error)
        this.dialog.loading = false
        this.dialog.type = 'error'
        this.dialog.text = errorText
        this.dialog.oneButtonDialog = true
        this.dialog.oneButtonText = i18n.t(
          'general.dialogComponent.acceptButtonText'
        )
      }
    },
    viewPersonDetail(item) {
      const mainThis = this
      store.dispatch('persons/setCurrentPerson', item).then(function() {
        mainThis.$router.push({
          name: 'PersonDetail',
          params: { id: item.uriId }
        })
      })
    },
    getUserProfile(person) {
      let profile = ''
      const USER_ADMINISTRATOR =
        '(' +
        i18n.t(
          'fleet_management.persons.person_info.labels.card_field_profile_business_account_admin'
        ) +
        ')'
      const USER_MONITORING =
        '(' +
        i18n.t(
          'fleet_management.persons.person_info.labels.card_field_profile_business_account_user'
        ) +
        ')'
      const USER_SUB_FLEET_ADMINISTRATOR =
        '(' +
        i18n.t(
          'fleet_management.persons.person_info.labels.card_field_profile_business_account_admin_subfleet'
        ) +
        ')'
      if (person.roles.includes('user')) {
        let idx = 0
        for (const { user } of person.profile) {
          if (Boolean(user)) {
            if (user[0] === 'business_account_admin')
              profile = USER_ADMINISTRATOR

            if (user[0] === 'business_account_user') profile = USER_MONITORING

            if (user[0] === 'business_account_fleet_admin')
              profile = USER_SUB_FLEET_ADMINISTRATOR
          }
          idx++
        }
      }

      return profile
    },
    customSort(items, index, isDesc) {
      let firstValue = null
      let secondValue = null
      items.sort((firstElement, secondElement) => {
        if (index[0] === 'email') {
          firstValue = firstElement.emails[0].email.toLowerCase()
          secondValue = secondElement.emails[0].email.toLowerCase()
        } else if (index[0] === 'fullName') {
          firstValue = firstElement.fullName.toLowerCase()
          secondValue = secondElement.fullName.toLowerCase()
        } else if (index[0] === 'roles') {
          firstValue = firstElement.roles[0] + this.getUserProfile(firstElement)
          secondValue =
            secondElement.roles[0] + this.getUserProfile(secondElement)
        }
        if (isDesc[0]) {
          return secondValue > firstValue ? 1 : -1
        } else {
          return firstValue > secondValue ? 1 : -1
        }
      })
      return items
    },
    showUserProfile(person, idx) {
      return Object.keys(person?.profile[idx] ?? {}).includes('user')
    },
    resize() {
      //each const represent an element, we calculate the avialiable size that the data-table can use
      const container = document.querySelector('.container.container--fluid')
        .offsetHeight
      const titleAndSearch = document.getElementById('titleAndSearch')
        .offsetHeight
      const tableHeader = document.querySelector('.card--title').offsetHeight
      const footer = document.querySelector('.v-footer').offsetHeight
      //viewPortHeight and we subtract the height of all the other elements
      const height = container - titleAndSearch - tableHeader - footer
      // 36 is the size of the padding that is not calculated before
      this.dataTableHeight = height - 36
    },
    contentBadge(uriId) {
      return Boolean(this.getThingsAssignments[uriId])
        ? this.getThingsAssignments[uriId].length
        : 0
    },
    async fillThingsAssignments() {
      const persons = store.state.persons.persons
      const batchSize = 40

      for (let i = 0; i < persons.length; i += batchSize) {
        const batch = persons.slice(i, i + batchSize)
        const batchPromises = batch.map(person =>
          this.$store.dispatch('persons/getThingsAssignmentList', {
            uriId: person.uriId
          })
        )
        await Promise.all(batchPromises)
      }
    }
  },
  computed: {
    ...mapGetters('persons', [
      'getPersons',
      'getResponseMessage',
      'getResponseError',
      'getThingsAssignments'
    ]),
    ...mapGetters(['isAdmin', 'isAdminSubFleet']),
    ...mapGetters(['getSearchInput', 'getMatchPosition']),
    persons() {
      const persons = Object.keys(this.getPersons).map(
        key => this.getPersons[key]
      )

      return persons
    },
    responseMessage() {
      if (this.getResponseError) {
        return this.getResponseMessage
      } else {
        return i18n.t('fleet_management.persons.persons_table.errors.no_data')
      }
    },
    totalPersons() {
      return this.getPersons.length
    }
  },
  watch: {
    getSearchInput() {
      const keyword = this.getSearchInput
      this.searchAndHighlight(keyword)
    },
    getMatchPosition() {
      this.matchPosition = this.getMatchPosition
      const keyword = this.getSearchInput
      this.searchAndHighlight(keyword)
    },
    async persons(newValue) {
      if (Object.keys(newValue).length > 0) {
        await this.fillThingsAssignments()
        this.loading = false
      }
    }
  },
  mounted() {
    addEventListener('resize', this.resize)
    this.$nextTick(function() {
      this.resize()
    })
  },
  created() {
    this.loading = true
  },
  beforeDestroy() {
    removeEventListener('resize', this.resize)
  },
  updated() {
    this.$nextTick(function() {
      this.context = document.querySelectorAll('.searchable')
      this.markInstance = new Mark(this.context)
    })
  }
}
</script>

<style lang="scss" scoped>
.scrollable-card {
  max-height: 200px;
  overflow-y: auto;
}
mark {
  background-color: var(--yellow-lighten-1);
  &.activeMatch {
    background-color: var(--orange-ligthen-1);
  }
}
#personsTable {
  .v-chip {
    background-color: #e9ecf0;
    border-color: #e9ecf0;
    color: var(--flat-blue-dark);
    font-weight: bold;
    font-size: 0.75rem;
  }
}

span.label-links:hover {
  text-decoration-line: underline;
  color: var(--deep-sky-blue) !important;
}

.tooltip-arrow {
  height: 0;
  width: 0;
  border-top: 6px solid var(--flat-blue-dark);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  position: absolute;
  left: calc(50% - 6px);
  margin-top: 5px;
}
.v-menu__content {
  contain: initial;
  overflow: visible;
}
.v-menu__content::before {
  position: absolute;
  content: '';
  top: 50%;
  right: -12px;
  transform: translateY(-50%);
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
</style>
